const initialState = {
    projects: [],
    project: null,
    isLoading: false,
    isError: false,
    errorMessage: '',
    projectUpdated: null,
    projectCreated: null,
}

export default function projectReducer(state = initialState, action: any) {
    switch (action.type) {
        case 'GET_ALL_PROJECTS':
            return { ...state, projects: action.payload, errorMessage: '', isError: false, isLoading: false };
        case 'GET_PROJECT':
            return { ...state, project: action.payload, errorMessage: '', isError: false, isLoading: false };
        case 'UPDATE_PROJECT':
            return { ...state, projectUpdated: action.payload, errorMessage: '', isError: false, isLoading: false };
        case 'CREATE_PROJECT':
            return { ...state, projectCreated: action.payload, errorMessage: '', isError: false, isLoading: false };
        case 'PROJECT_ACTION_STARTS':
            return { 
                ...state, 
                isLoading: true,
                projectCreated: null,
                projectUpdated: null,
                isError: false,
                errorMessage: ''
            };
        case 'PROJECT_ACTION_ERRORS':
            return { ...state, isError: true, errorMessage: action.payload, isLoading: false };
        case 'RESET_PROJECT_ERRORS':
            return { 
                ...state, 
                isError: false, 
                errorMessage: '',
            };
        default:
            return state;
    }
}